@use '@ingka/base/_mixins.scss' as *;
@use '../../../../constants.scss' as *;
@use '@ingka/variables/style.scss' as *;

.wrapper {
  padding-inline: $space-200;
}

.headingArea {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  margin-block-end: $space-150;
}

.cardInfo {
  place-self: start center;
}

.loyaltyButton {
  display: flex;
  align-items: center;
  gap: $space-50;
  background: $colour-neutral-2;
  border: none;
  padding: 6px;
  border-radius: $radius-s;
  cursor: pointer;
}

.loyaltyButton:hover {
  background: $colour-neutral-3;
}

.loyaltyButton:focus-visible {
  outline-color: black;
}

.heading {
  color: $colour-text-and-icon-1;
}

.listView {
  margin-block-end: $space-125;
}

.listViewItem:first-child {
  border-top: 1px solid $colour-elevation-1;
}
